import { useDispatch } from "react-redux";
import { removeSection } from "../../../reducers/sectionManagement/thunkActions";
import { Modal } from "../Modal";
import { RemoveSectionContent } from "./RemoveSectionContent";
import { RemoveSectionActions } from "./RemoveSectionActions";

export const RemoveSectionModal = ({ onClose, section }) => {
  const dispatch = useDispatch();

  const onContinue = async () => {
    const { error } = await dispatch(removeSection(section));
    !error && onClose();
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      title={"Remove Section"}
      content={<RemoveSectionContent section={section} />}
      actions={
        <RemoveSectionActions onCancel={onClose} onContinue={onContinue} />
      }
      maxWidth={"sm"}
    />
  );
};
